// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"abf40636","453":"55c3f9cb","455":"58c81694","977":"7f2d2869"}[chunkId] + ".chunk.js";
};